module.exports = __webpack_public_path__ + "static/media/icon-pool-pump.8a80ce04.svg";